import { createAsyncThunk } from '@reduxjs/toolkit';
import SharePropertiesMultipleSourcesService from '@/services/SharePropertiesMultipleSourcesService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`SharePropertiesMultipleSources/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

export const getContacts = handler(
  'getContacts',
  SharePropertiesMultipleSourcesService.getContacts
);

export const postValidateContactChannel = handler(
  'postValidateContactChannel',
  SharePropertiesMultipleSourcesService.postValidateContactChannel
);

export const postCreateMessageContact = handler(
  'postCreateMessageContact',
  SharePropertiesMultipleSourcesService.postCreateMessageContact
);
